__turbopack_context__.v({
  "background_is_white": "styles-module-scss-module__s71ADq__background_is_white",
  "navigation": "styles-module-scss-module__s71ADq__navigation",
});
